import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-logout\">\r\n    <path d=\"M5 5v20.05h12v-6.08h-2.03v4h-8v-16h8v4H17V5zm15.04 5.12L25 15.08l-4.96 4.96-1.44-1.44 2.56-2.56h-9.12v-2.03h9.17l-2.56-2.56z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol